import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  GET_PASSWORD,
  GET_PASSWORD_SUCCESSFUL,
  GET_PASSWORD_FAILED,
  CREATE_NEW_USER,
  CREATE_NEW_USER_SUCCESSFUL,
  CREATE_NEW_USER_FAILED,
} from "./actionTypes"

export const registerUser = user => {
  console.log(user)
  return {
    type: REGISTER_USER,
    payload: { user },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}

export const getPassword = password => {
 console.log(password)
  return {
    type: GET_PASSWORD,
    payload: {password },
  }
}

export const getPasswordSuccessful = password => {
  return {
    type: GET_PASSWORD_SUCCESSFUL,
    payload: password,
  }
}

export const getPasswordFailed = error => {
  return {
    type: GET_PASSWORD_FAILED,
    payload: error,
  }
}


export const createNewUser = user => {
 console.log(user)
  return {
    type: CREATE_NEW_USER,
    payload: {user},
  }
}

export const createNewUserSuccessful = user => {
  return {
    type: CREATE_NEW_USER_SUCCESSFUL,
    payload: user,
  }
}

export const createNewUserFailed = error => {
  return {
    type: CREATE_NEW_USER_FAILED,
    payload: error,
  }
}



